module.exports = __webpack_public_path__ + "img/03.00ada906.png";